module.exports = __webpack_public_path__ + "static/media/mission.c04af1ea.png";